import React, { FC } from 'react';

import classNames from 'classnames';

import { EvSkeleton } from '@evinced-private/ui-common';

import { FilterRows } from 'src/common/components/skeletons/FilterRows';
import { TableSkeleton } from 'src/common/components/skeletons/table-skeleton/TableSkeleton';

import './WfaSessionAllIssuesSkeleton.scss';

interface WfaSessionAllIssuesSkeletonProps {
	isAnimated?: boolean;
	isOverlay?: boolean;
}

export const WfaSessionAllIssuesSkeleton: FC<WfaSessionAllIssuesSkeletonProps> = ({
	isAnimated = true,
	isOverlay = false
}) => {
	const animationSpeed = isAnimated ? undefined : 0;
	const filterHeight = '60px';

	return (
		<div
			className={classNames('wfa-session-all-issues-skeleton', {
				'wfa-session-all-issues-skeleton--overlay': isOverlay
			})}
		>
			{/* Header Section */}
			<div className="skeleton-header">
				<div className="skeleton-title-row">
					<div className="skeleton-title">
						<EvSkeleton height="28px" width="200px" animationSpeed={animationSpeed} />
					</div>
					<div className="skeleton-actions">
						<EvSkeleton height="32px" width="32px" animationSpeed={animationSpeed} />
						<EvSkeleton height="32px" width="32px" animationSpeed={animationSpeed} />
					</div>
				</div>

				{/* ReportInfo Skeleton */}
				<div className="skeleton-info-section">
					<div className="skeleton-info-items">
						<div className="skeleton-data-item">
							<EvSkeleton height="46px" width="142px" animationSpeed={animationSpeed} />
						</div>
						<div className="skeleton-data-item">
							<EvSkeleton height="46px" width="90px" animationSpeed={animationSpeed} />
						</div>
						<div className="skeleton-data-item">
							<EvSkeleton height="46px" width="60px" animationSpeed={animationSpeed} />
						</div>
					</div>
				</div>
			</div>

			{/* Tabs Skeleton */}
			<div className="skeleton-tabs">
				<EvSkeleton height="24px" width="80px" animationSpeed={animationSpeed} />
				<EvSkeleton height="24px" width="100px" animationSpeed={animationSpeed} />
				<EvSkeleton height="24px" width="80px" animationSpeed={animationSpeed} />
			</div>

			{/* Content Section */}
			<div className="skeleton-content">
				{/* Filters section skeleton */}
				<div className="skeleton-filters-section">
					<div className="skeleton-filters-rows">
						<FilterRows
							count={1}
							height={filterHeight}
							width="330px"
							animationSpeed={animationSpeed}
							keySet={['search']}
						/>
						<FilterRows
							count={4}
							height={filterHeight}
							width="140px"
							animationSpeed={animationSpeed}
							keySet={Array.from({ length: 4 }, (_, i) => `filter_${i}`)}
						/>
						<FilterRows
							count={2}
							height="40px"
							width="70px"
							animationSpeed={animationSpeed}
							keySet={Array.from({ length: 2 }, (_, i) => `action_${i}`)}
						/>
					</div>
				</div>

				{/* Table Skeleton */}
				<TableSkeleton columns={6} rowCount={5} />
			</div>
		</div>
	);
};
